export default __webpack_public_path__ + "static/media/question.a6765c64.png";